import { Timezone } from "../../../../../../../constant/Timezone"
import { getDayWithFormat } from "../../../../../../../utils/getDate"

const { DATE_FORMAT_EN } = Timezone

export const getDisplayDateTime = (csvDateTime: string) => {
  return csvDateTime
    ? getDayWithFormat(DATE_FORMAT_EN, csvDateTime)
    : csvDateTime
}
